import generateYears from '../utilities/generateYears';
import getSchoolList from './getSchoolList';

// set constants
const positions = [
  'All',
  'QB',
  'RB',
  'WR',
  'TE',
  'FB',
  'OC',
  'OG',
  'OT',
  'S',
  'CB',
  'LB',
  'DE',
  'DT',
  'K',
  'P',
  'LS',
  'ATH',
];
const stateList = [
  'All',
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MH',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'PW',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];
const statuses = ['All', 'Committed', 'Offered', 'Active', 'Eval'];
const schools = getSchoolList();
const colors = { red: '#FF4A26', yellow: '#FFFB26', lightgreen: '9EFF28', darkgreen: '#60DD00' };

const userTable = 'masterUsers';
const userSchools = ['zmailtest'];
const { years, endYear, startYear } = generateYears();
const schoolToConfMap = require('./schoolToConfMap.json');
const stateCounties = require('./frontendCounties.json');
// const conferenceSchools = require('./conferenceToSchool.json');

// combine into object for exports
export default {
  PLAYERS_PER_PAGE: 25,
  START_YEAR: startYear,
  END_YEAR: endYear,
  NUM_YEAR_SHOWN: 3,
  POSITIONS: positions,
  STATES: stateList,
  STATE_COUNTIES: stateCounties,
  NUM_VISIBLE_PAGES: 10,
  STATUSES: statuses,
  SCHOOLS: schools,
  NOTIFICATION_TABLE: 'notificationsMaster',
  YEARSTAB: years,
  COLORS: colors,
  USER_SCHOOLS: userSchools,
  SCHOOLTOCONFMAP: schoolToConfMap,
  USER_TABLE: userTable,
};



// WEBPACK FOOTER //
// ./src/constants/appConstants.js